import { useState } from "react";

import type { MediaImageDataFragment } from "../graphql/types";

export interface MediaImageProps {
  image: MediaImageDataFragment;
  className?: string;
  visible: boolean;
  prefetch?: boolean;
  sizes?: string;
}

export function MediaImage(props: MediaImageProps) {
  const { image, className, sizes, visible, prefetch } = props;

  const [loaded, setLoaded] = useState(false);

  const supportsLazyLoading =
    typeof window !== "undefined"
      ? "loading" in HTMLImageElement.prototype
      : false;

  const supportsSrcSet =
    image.source_set &&
    (typeof window !== "undefined"
      ? "srcset" in HTMLImageElement.prototype
      : false);

  const applySource = visible || loaded || prefetch === true;

  return (
    <img
      alt={image.alt ?? "image"}
      loading={supportsLazyLoading ? (prefetch ? "eager" : "lazy") : undefined}
      src={
        applySource && !supportsSrcSet ? (image.source ?? undefined) : undefined
      }
      width={image.width ?? undefined}
      height={image.height ?? undefined}
      srcSet={applySource ? (image.source_set ?? undefined) : undefined}
      sizes={sizes}
      className={className}
      onLoad={() => setLoaded(true)}
    />
  );
}
